import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import './index.css';

const container = document.getElementById('root');

const tree = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// The production build is prerendered to static HTML (see prerender.js), so in
// the browser the container already holds server-rendered markup. Hydrate it
// rather than throwing it away, otherwise React discards the prerendered DOM
// and the page flashes blank on first paint.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
